/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'minus': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" _fill="#000" d="M20.96 11.4c.353 0 .64.269.64.6a.61.61 0 01-.525.59l-.115.01H3.04c-.353 0-.64-.269-.64-.6a.61.61 0 01.525-.59l.115-.01h17.92z" fill-rule="evenodd"/>'
  }
})
